import React from 'react';
import { TMessage } from '../../store/sockets/types';
import { DEF_MARGIN } from '../../utils/consts';
import { EIcons } from '../../utils/globatTypes';
import { TitleBlock } from '../TitleBlock';
import { IframeForVideo } from './IframeForVideo';
import { MessageUnderVideo } from './MessageUnderVideo';
import { HeaderS, WrapperS } from './styles';
import { CallToAction } from '../CallToAction';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { setVideo, setVideoHide } from '../../store/video/actions';
import { useActionsMarketing } from '../../hooks/useActionsMarketing';

interface VideoProps {
  link?: string;
  message?: TMessage | null;
  likeMessage?: (messageId: number) => void;
}

export const Video: React.FC<VideoProps> = ({ link, message, likeMessage }) => {
  const { Video } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { loadedVideo } = useActionsMarketing();

  return (
    <WrapperS isHideVideo={Video.isHideVideo} isFullScreen={Video.isFullScreen}>
      <HeaderS isFullScreen={Video.isFullScreen} className="headerBlock">
        <div style={{ flex: 1, marginBottom: DEF_MARGIN }}>
          <TitleBlock icon={EIcons.video} title="Вiдео" />
        </div>
        {!Video.isFullScreen && <button onClick={() => dispatch(setVideoHide(!Video.isHideVideo))}>_</button>}
        <button onClick={() => dispatch(setVideo(!Video.isFullScreen))}>
          <i className="ion-qr-scanner" />
        </button>
      </HeaderS>
      <div style={{ position: 'relative', height: '100%' }}>
        <IframeForVideo isFullScreen={Video.isFullScreen} link={link} onLoad={loadedVideo} />
        {Video.isFullScreen && <CallToAction />}
      </div>
      {message && Video.isFullScreen && likeMessage ? (
        <MessageUnderVideo isFullScreen={Video.isFullScreen} message={message} likeMessage={likeMessage} />
      ) : null}
      {message && !Video.isFullScreen && !Video.isHideVideo && likeMessage ? (
        <MessageUnderVideo isFullScreen={Video.isFullScreen} message={message} likeMessage={likeMessage} />
      ) : null}
    </WrapperS>
  );
};
